'use client';

import { usePathname } from 'next/navigation';

import { Condition } from '@/components/static';
import { STATIC_PAGES_PATH_NAMES } from '@/constant/routes';
import { useHeaderRightSectionCtx } from '@/hooks/ctx';

import { GlobalNavigation } from '../GlobalNavigation';
import { ConsoleButton } from './ConsoleButton';
import s from './styles.module.scss';
import { UserDetails } from './UserDetails';

export function BurgerContent() {
  const ctx = useHeaderRightSectionCtx();
  const pathname = usePathname();
  return (
    <div className={s.burger_content_wrapper}>
      <UserDetails />
      <Condition when={pathname !== STATIC_PAGES_PATH_NAMES.serp}>
        <GlobalNavigation triggerClassName={s.full_width} toggleIsShowContent={ctx.toggleIsOpenBurgerContent} />
      </Condition>

      <ConsoleButton size='m' fullWidth />
    </div>
  );
}
